import React, { useState } from "react";
import {
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  InputAdornment,
  Typography,
} from "@mui/material";
import passwordIcon from "../../common/assests/password.png";
import backImg from "../../common/assests/backImg.png";
import { toast } from "react-toastify";
import CustomBtn from "../../common/customButton/CustomBtn";
import { handleChangePassApi } from "../../api";
import CloseEyeIcon from "../../common/assests/eclose.svg";
import OpenEyeIcon from "../../common/assests/eopen.svg";
import Loader from "../../common/loader/Loader";

const ConfirmPassModal = ({ onSubmit, onBack, refId }) => {
  const [btnDisable, setBtnDisable] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); 
  const [loading,setLoading]=useState(false);


  const handleToggleNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleToggleConfirmPassword = () => setShowConfirmPassword((prev) => !prev);

  const handleSubmitNewPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.warning("All fields are required");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.warning("Passwords did not match");
      return;
    }
    if (newPassword.length < 8) {
      toast.warning("Password should be at least 8 characters long");
      return;
    }
    const isConfirmed = window.confirm(
      "Are you sure, you want to Change your password?"
    );
    if (!isConfirmed) {
      return;
    }
    try {
      setLoading(true)
      setBtnDisable(true);
      const response = await handleChangePassApi({ refId, newPassword });
      toast.success(response.message);
      setNewPassword("");
      setConfirmPassword("");
      onSubmit();
      setLoading(false)
    } catch (error) {
      setBtnDisable(false);
      setLoading(false)
      toast.error(error.message);
      console.log("error", error);
    }
  };

  return (
    <>
    {loading ? (
        <Loader variant="form" />
    ):(
      <DialogContent sx={{ padding: "10px" }}>
      <Box sx={{ marginTop: '20px', paddingLeft: '20px' }}>
        <Typography
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "20%",
            alignItems: "center",
            cursor: "pointer",
            gap: '10px'
          }}
          onClick={onBack}
        >
          <img
            src={backImg}
            alt="backImg"
            style={{ height: "29px", width: "29px" }}
          />
          <Typography
            sx={{ color: "#065F46", fontWeight: "500", fontSize: "20px" }}
          >
            Back
          </Typography>
        </Typography>
      </Box>

      <DialogTitle
        sx={{
          textAlign: "left",
          fontSize: "24px",
          fontWeight: "700",
          fontFamily: "Heebo",
          marginTop: '20px',
          paddingLeft: '30px'
        }}
      >
        Set New Password
      </DialogTitle>
      <DialogTitle
        sx={{
          marginTop: "-27px",
          fontSize: "14px",
          fontWeight: "400",
          fontFamily: "Heebo",
          opacity: "0.5",
          paddingLeft: '30px'
        }}
      >
        Set your password here whatever you wanted
      </DialogTitle>

      {/* New Password Field */}
      <Box sx={{ width: "90%", margin: "0 auto" }}>
        <Typography
          sx={{
            marginBottom: "8px",
            marginTop: '20px',
            textAlign: "left",
            marginLeft: "20px",
            fontSize: "17px",
            fontWeight: "600",
            fontFamily: "Heebo",
            color: "#171717",
          }}
        >
          New Password
        </Typography>
        <TextField
          fullWidth
          type={showNewPassword ? "text" : "password"} 
          placeholder="Type your new password"
          value={newPassword}
          onChange={(e) => 
            {
              if (e.target.value.trim() !== "" || e.target.value === "") {
            setNewPassword(e.target.value)}
              }
            }
          sx={{
            borderRadius: "28px",
            marginBottom: "12px",
            fontSize: '10px'
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img
                  src={passwordIcon}
                  alt="password-icon"
                  style={{ width: "20px" }}
                />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <img
                  src={showNewPassword ? OpenEyeIcon : CloseEyeIcon}
                  alt="toggle-password-visibility"
                  onClick={handleToggleNewPassword}
                  style={{ width: "20px", cursor: "pointer", opacity: '0.4' }}
                />
              </InputAdornment>
            ),
            style: { borderRadius: "28px" },
          }}
        />
      </Box>

      {/* Retype Password Field */}
      <Box sx={{ width: "90%", margin: "0 auto" }}>
        <Typography
          sx={{
            marginBottom: "8px",
            textAlign: "left",
            marginLeft: "20px",
            fontSize: "17px",
            fontWeight: "600",
            fontFamily: "Heebo",
            marginTop: '10px'
          }}
        >
          Retype Password
        </Typography>
        <TextField
          fullWidth
          type={showConfirmPassword ? "text" : "password"} 
          placeholder="Retype your password"
          value={confirmPassword}
          onChange={(e) => 
            {
              if (e.target.value.trim() !== "" || e.target.value === "") {
            setConfirmPassword(e.target.value)}
              }
            }
          sx={{
            borderRadius: "28px",
            marginBottom: "20px",
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img
                  src={passwordIcon}
                  alt="password-icon"
                  style={{ width: "20px" }}
                />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <img
                  src={showConfirmPassword ? OpenEyeIcon : CloseEyeIcon}
                  alt="toggle-password-visibility"
                  onClick={handleToggleConfirmPassword}
                  style={{ width: "20px", cursor: "pointer", opacity: '0.4' }}
                />
              </InputAdornment>
            ),
            style: { borderRadius: "28px" },
          }}
        />
      </Box>

      <Box
        sx={{
          width: "90%",
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
          marginTop: '15px',
          marginBottom: '20px'
        }}
      >
        <CustomBtn onClick={handleSubmitNewPassword} text="Submit" disable={btnDisable} />
      </Box>
    </DialogContent>
    )}
    
    </>
  );
};

export default ConfirmPassModal;
